export default "__VITE_ASSET__66143187__"